/** --------------------------------------------------
*
*   paragraphs
*   PARAGRAPH: PHOTO GALLERY
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.paragraph_photo_gallery = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      if (!once('paragraph_photo_gallery', 'html').length) {
        return;
      }
      self.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      const galleryParagraphs = document.querySelectorAll('.js-p-gallery[data-lightbox="true"]');
      galleryParagraphs.forEach(function(element) {
        const galleryParagraph = element;

        // setup lightbox galleries:
        self._setupLightbox(galleryParagraph);
      });
    },

    _setupLightbox: function(galleryParagraph) {

      // prepare lightbox galleries:
      // - generate a unique "data-fancybox" attribute value per paragraph,
      //   in order to create a separate gallery for each gallery paragraph
      // - update the fancybox options per gallery paragraph

      // unique id for this paragraph:
      const paragraphId = 'p-gallery-' + duo.Utils.uniqueId;

      // make all fancybox links within the paragraph visible and add a unique id:
      const galleryLinks = galleryParagraph.querySelectorAll('[data-lightbox]');
      galleryLinks.forEach(function(element) {
        const galleryLink = element;
        galleryLink.removeAttribute('hidden');
        galleryLink.setAttribute('data-fancybox', paragraphId);
      });
      
      // update fancybox options:
      const fancyBoxSelector = `.js-p-gallery [data-fancybox="${ paragraphId }"]`;
      Fancybox.bind(fancyBoxSelector, {
        animated: false,
        closeButton: 'outside',
        dragToClose: false,
        infinite: false,
        showClass: false,

        Thumbs: true,

        Image: {
          zoom: false,
          wheel: false,
          click: false,
        },

        Toolbar: {
          display: ["close"],
        },

        l10n: {
          CLOSE: Drupal.t('Close'),
          NEXT: Drupal.t('Next'),
          PREV: Drupal.t('Previous'),
          MODAL: Drupal.t('You can close this modal with the ESC key'),
          ERROR: Drupal.t('Something went wrong, please try again'),
          IMAGE_ERROR: Drupal.t('Image not found'),
          ELEMENT_NOT_FOUND: Drupal.t('HTML element not found'),
          AJAX_NOT_FOUND: Drupal.t('Error loading AJAX: not found'),
          AJAX_FORBIDDEN: Drupal.t('Error loading AJAX: forbidden'),
          IFRAME_ERROR: Drupal.t('Error loading page')
        }
      });
    }
  };
})(Drupal, once, window.duo = window.duo || {});
